import { ALL_LOG_LEVELS } from "./constants";

const getLogLevelsDictionary = () =>
  ALL_LOG_LEVELS.reduce(
    (levelsEnum, levelName) => ({
      ...levelsEnum,
      [levelName]: levelName
    }),
    {}
  );

export default getLogLevelsDictionary;
